var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"10px 0px 0px"}},[_c('center',[_c('a',{attrs:{"href":"https://pill.com.co/"}},[_c('v-img',{attrs:{"src":"https://d153chakadu90d.cloudfront.net/web/Powered_pill.webp","max-height":"100","max-width":"100","alt":"pill oportunidades logo"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }